exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".view-error403 .knight{text-align:center;position:absolute;top:90px;left:650px}.view-error403 .error-message{padding-bottom:150px}@media only screen and (max-width:1040px){.view-error403 .knight{position:relative;top:0;left:0;margin-top:30px;margin-bottom:30px}.view-error403 .error-message{padding-bottom:0}}", ""]);

// exports
